import '../css/app.css';

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';
import App from './App.vue';
import router from './router/index.js';
// Motyw nakładany przy starcie aplikacji, nie przy imporcie paska zalogowanego
// widoku. Bez tego strony BEZ paska — publiczne udostępnianie, logowanie —
// zostawały w jasnym motywie niezależnie od wyboru użytkownika (2026-07-30).
import '@/composables/useDarkMode';

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(PrimeVue, {
    unstyled: true,
    // Overlaye (DatePicker, Select) muszą przykrywać modale Teleport (z-[9999])
    zIndex: { overlay: 10000, menu: 10000, tooltip: 10100, modal: 11000 },
    // Polska lokalizacja komponentów (DatePicker: dni, miesiące, przyciski)
    locale: {
        firstDayOfWeek: 1,
        dayNames: ['niedziela', 'poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota'],
        dayNamesShort: ['ndz', 'pon', 'wt', 'śr', 'czw', 'pt', 'sob'],
        dayNamesMin: ['Nd', 'Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So'],
        monthNames: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'],
        monthNamesShort: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
        today: 'Dziś',
        clear: 'Wyczyść',
        weekHeader: 'Tydz.',
        dateFormat: 'dd.mm.yy',
        emptyMessage: 'Brak wyników',
        emptySelectionMessage: 'Nie wybrano',
        emptySearchMessage: 'Brak wyników',
        selectionMessage: '{0} wybrano',
    },
});
app.use(ToastService);
app.use(ConfirmationService);

app.mount('#app');
